import controller from './campaign-dialog.controller';

export default {
  controller,
  template: require('./campaign-dialog.html')
};



// WEBPACK FOOTER //
// src/app/components/campaign-dialog/campaign-dialog.component.ts